import { Dialog } from '@artosera/ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useCreerArticle, type CorpsArticle } from '../../api/presse.js';
import { useShellContext } from '../shell/context.js';
import { FormArticle } from './FormArticle.js';
export function NouvelArticleDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
}) {
  const { t } = useTranslation(['regie', 'commun']);
  const { galerieSlug } = useShellContext();
  const creer = useCreerArticle(galerieSlug);
  const navigate = useNavigate();
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('regie:presse.ajouter')}
      closeLabel={t('commun:actions.fermer')}
    >
      {open ? (
        <FormArticle
          galerieSlug={galerieSlug}
          attente={creer.isPending}
          enregistrer={async (c) => {
            const { article } = await creer.mutateAsync(c as CorpsArticle);
            onOpenChange(false);
            void navigate(`/${galerieSlug}/presse/${article.id}`);
          }}
        />
      ) : null}
    </Dialog>
  );
}
